import React from "react";
import { useTranslation } from "react-i18next";
import { Compass } from "lucide-react";

import TourCardComponent from "./TourCard";

import background from "../assets/images/background.png";
import betocarrero from "../assets/images/betocarrero.jpeg";
import blumenau from "../assets/images/blumenau.jpeg";
import campeche from "../assets/images/campeche.jpeg";
import centrohistorico from "../assets/images/centrohistorico.jpeg";
import pontehercilio from "../assets/images/pontehercilio.jpeg";

const tours = (t: (key: string) => string) => [
  {
    image: betocarrero,
    title: t("tours.betoCarrero.title"),
    description: t("tours.betoCarrero.description"),
  },
  {
    image: blumenau,
    title: t("tours.oktoberfest.title"),
    description: t("tours.oktoberfest.description"),
  },
  {
    image: campeche,
    title: t("tours.campeche.title"),
    description: t("tours.campeche.description"),
  },
  {
    image: centrohistorico,
    title: t("tours.historicCenter.title"),
    description: t("tours.historicCenter.description"),
  },
  {
    image: pontehercilio,
    title: t("tours.bridgeHercilio.title"),
    description: t("tours.bridgeHercilio.description"),
  },
];

const ToursComponent = () => {
  const { t } = useTranslation();

  return (
    <section className="relative isolate bg-slate-900 py-20 text-white">
      <div className="absolute inset-0 opacity-20">
        <img
          src={background}
          alt={t("tours.backgroundAlt")}
          className="h-full w-full object-cover"
        />
      </div>
      <div className="relative z-10 mx-auto flex max-w-6xl flex-col gap-10 px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full border border-white/30 px-4 py-2 text-xs uppercase tracking-[0.4em] text-white">
            <Compass className="h-4 w-4" /> {t("appbar.tours")}
          </p>
          <h2 className="mt-6 text-3xl font-semibold md:text-4xl">
            {t("tours.title")}
          </h2>
          <p className="mt-2 text-base text-white/80">
            {t("tours.description")}
          </p>
        </div>
        <div className="flex gap-6 overflow-x-auto scroll-smooth px-1 pb-4 [scrollbar-width:none] md:grid md:grid-cols-3 md:gap-6">
          {tours(t).map((tour) => (
            <div
              key={tour.title}
              className="min-w-[280px] snap-center md:min-w-0"
            >
              <TourCardComponent {...tour} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToursComponent;
